import { render, staticRenderFns } from "./_base-file-picker.vue?vue&type=template&id=515a7bc3&"
import script from "./_base-file-picker.vue?vue&type=script&lang=js&"
export * from "./_base-file-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-file-picker.vue?vue&type=style&index=0&id=515a7bc3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports